import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_googlegtag_7b8a2475 from 'nuxt_plugin_googlegtag_7b8a2475' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_googletagmanager_515a7cec from 'nuxt_plugin_googletagmanager_515a7cec' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_rollbarclient_02f598d0 from 'nuxt_plugin_rollbarclient_02f598d0' // Source: ./rollbar-client.js (mode: 'all')
import nuxt_plugin_nuxtdevicedetectplugin4cda4423_726cd3f0 from 'nuxt_plugin_nuxtdevicedetectplugin4cda4423_726cd3f0' // Source: ./nuxt-device-detect.plugin.4cda4423.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_firebase_5cf99106 from 'nuxt_plugin_firebase_5cf99106' // Source: ../src/plugins/firebase (mode: 'all')
import nuxt_plugin_nl2br_3404d064 from 'nuxt_plugin_nl2br_3404d064' // Source: ../src/plugins/nl2br (mode: 'all')
import nuxt_plugin_text2link_2f7b9f69 from 'nuxt_plugin_text2link_2f7b9f69' // Source: ../src/plugins/text2link (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../src/plugins/vuelidate (mode: 'all')
import nuxt_plugin_dependencyInjection_70acde96 from 'nuxt_plugin_dependencyInjection_70acde96' // Source: ../src/plugins/dependencyInjection (mode: 'all')
import nuxt_plugin_actionLogger_9fdc0c48 from 'nuxt_plugin_actionLogger_9fdc0c48' // Source: ../src/plugins/actionLogger (mode: 'client')
import nuxt_plugin_userLastAccessUpdater_b81f0ce4 from 'nuxt_plugin_userLastAccessUpdater_b81f0ce4' // Source: ../src/plugins/userLastAccessUpdater (mode: 'client')
import nuxt_plugin_ga_5d03ba60 from 'nuxt_plugin_ga_5d03ba60' // Source: ../src/plugins/ga (mode: 'client')
import nuxt_plugin_errorHandler_caf842d0 from 'nuxt_plugin_errorHandler_caf842d0' // Source: ../src/plugins/errorHandler (mode: 'client')
import nuxt_plugin_autoAccountSwitcher_f90c196e from 'nuxt_plugin_autoAccountSwitcher_f90c196e' // Source: ../src/plugins/autoAccountSwitcher (mode: 'client')
import nuxt_plugin_priceFormatter_7e045677 from 'nuxt_plugin_priceFormatter_7e045677' // Source: ../src/plugins/priceFormatter (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"クラウドリンクス｜副業・フリーランスのハイクラスマッチングサービス","htmlAttrs":{"lang":"ja"},"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"default"},{"hid":"description","name":"description","content":"クラウドリンクス（CrowdLinks）は、クラウドワークスが提供するハイクラスなマッチングサービスです。エンジニア・デザイナー・マーケター・人事など幅広い職種の方にご登録いただいています。"},{"hid":"og:site_name","property":"og:site_name","content":"クラウドリンクス"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fcrowdlinks.jp"},{"hid":"og:title","property":"og:title","content":"クラウドリンクス"},{"hid":"og:description","property":"og:description","content":"クラウドリンクス（CrowdLinks）は、クラウドワークスが提供するハイクラスなマッチングサービスです。エンジニア・デザイナー・マーケター・人事など幅広い職種の方にご登録いただいています。"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcrowdlinks.jp\u002Fogp.png"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@CrowdWorksjp"},{"hid":"fb:app_id","property":"fb:app_id","content":"3438505862841552"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"s8v5u1io34vy9y8yf0j66ysbhuqvy2"}],"script":[{"hid":"skip-hydration","innerHTML":"(function (){var e=document.getElementById('__nuxt');if(e){e.removeAttribute('data-server-rendered');return}var o=new MutationObserver(function(){var e=document.getElementById('__nuxt');if(e){e.removeAttribute('data-server-rendered');o.disconnect()}});o.observe(document.documentElement,{childList:true,subtree:true});})();","type":"text\u002Fjavascript"},{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-NB4GCFM&l=dataLayer","async":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-ZKP1KMXKET","async":true}],"__dangerouslyDisableSanitizersByTagID":{"skip-hydration":["innerHTML"],"gtm-noscript":["innerHTML"]},"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fmeyer-reset\u002F2.0\u002Freset.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons|Material+Icons+Outlined"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans&family=Noto+Sans+JP&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NB4GCFM&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_7b8a2475 === 'function') {
    await nuxt_plugin_googlegtag_7b8a2475(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_515a7cec === 'function') {
    await nuxt_plugin_googletagmanager_515a7cec(app.context, inject)
  }

  if (typeof nuxt_plugin_rollbarclient_02f598d0 === 'function') {
    await nuxt_plugin_rollbarclient_02f598d0(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtdevicedetectplugin4cda4423_726cd3f0 === 'function') {
    await nuxt_plugin_nuxtdevicedetectplugin4cda4423_726cd3f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_firebase_5cf99106 === 'function') {
    await nuxt_plugin_firebase_5cf99106(app.context, inject)
  }

  if (typeof nuxt_plugin_nl2br_3404d064 === 'function') {
    await nuxt_plugin_nl2br_3404d064(app.context, inject)
  }

  if (typeof nuxt_plugin_text2link_2f7b9f69 === 'function') {
    await nuxt_plugin_text2link_2f7b9f69(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (typeof nuxt_plugin_dependencyInjection_70acde96 === 'function') {
    await nuxt_plugin_dependencyInjection_70acde96(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_actionLogger_9fdc0c48 === 'function') {
    await nuxt_plugin_actionLogger_9fdc0c48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_userLastAccessUpdater_b81f0ce4 === 'function') {
    await nuxt_plugin_userLastAccessUpdater_b81f0ce4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ga_5d03ba60 === 'function') {
    await nuxt_plugin_ga_5d03ba60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errorHandler_caf842d0 === 'function') {
    await nuxt_plugin_errorHandler_caf842d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_autoAccountSwitcher_f90c196e === 'function') {
    await nuxt_plugin_autoAccountSwitcher_f90c196e(app.context, inject)
  }

  if (typeof nuxt_plugin_priceFormatter_7e045677 === 'function') {
    await nuxt_plugin_priceFormatter_7e045677(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
